import {Component, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RegistryService} from '../../services/registry.service';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.css']
})
export class SiteFooterComponent implements OnInit,OnDestroy {

    settingsLoadedEvent;

    constructor(
        private _renderer2: Renderer2,
        private registry: RegistryService,
        @Inject(DOCUMENT) private _document: Document
    ) {

       this.settingsLoadedEvent  = this.registry.SettingsLoadedEvent$.subscribe(settings =>{
            this. injectChatBot();

        })
    }

    env = environment

    ngOnInit() {

    }

    injectChatBot() {

        const script = this._renderer2.createElement('script');
        let bot_id= this.registry.getSettingByID('intercom_script')

        // if(bot_id != null) {
        //   //  script.id = "webchat__widget";
        //    script.id = "growth_tool";
        //    // script.src = "https://cdn.chatapi.net/webchat/widget/widget.js?cId="+bot_id;
        //     script.src = "https://cdn.chatapi.net/widget/widget.js?wId="+bot_id;
        //     this._renderer2.appendChild(this._document.body, script);
        // }

    }

    ngOnDestroy(): void {

        if(this.settingsLoadedEvent)
        {
            this.settingsLoadedEvent.unsubscribe();
        }
    }

}
